// tslint:disable:max-line-length

import React from 'react';

export const ActionInstall = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0,9h16v7H0V9z M14,11H2v3h12V11z M9,0v4.4h3L8,8L4,4.4h3V0H9z" />
    </svg>
  );
};
